"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildGA4ProductDetailInteraction = exports.buildGA4ProductDetail = void 0;
const enums_1 = require("../enums");
const getVariant_1 = require("../helper/getVariant");
const calculateProductIfrs_1 = require("./calculateProductIfrs");
const getPriceCategory = (product) => {
    if (product.originalPrice) {
        return enums_1.GA4PriceCategory.Special;
    }
    if (product.hasFriendsDiscount) {
        return enums_1.GA4PriceCategory.FriendsDiscount;
    }
    return enums_1.GA4PriceCategory.Regular;
};
function buildGA4ProductDetail({ product, variant, appointment, isLocationSelected, quantity, itemListName, tenant, offsetShare, orderDiscountRate, }) {
    const [category, category2, category3, category4] = product.trackingPath;
    const itemIfrs = tenant !== undefined &&
        offsetShare !== undefined &&
        orderDiscountRate !== undefined &&
        quantity !== undefined
        ? (0, calculateProductIfrs_1.calculateProductIfrs)({
            product,
            tenant,
            quantity,
            offsetShare,
            orderDiscountRate,
            appointment,
        })
        : undefined;
    return {
        item_id: product.manufacturerSku,
        item_name: product.title,
        price: product.originalPrice
            ? product.originalPrice.gross.amount
            : product.price.gross.amount,
        price_category: getPriceCategory(product),
        price_special: product.originalPrice ? product.price.gross.amount : undefined,
        item_brand: '',
        item_category: category || '',
        item_category2: category2 || '',
        item_category3: category3 || '',
        item_category4: category4 || '',
        item_variant: variant || (0, getVariant_1.getVariant)(appointment, product.productType),
        item_rating: product.rating?.value,
        item_rating_count: product.rating?.count,
        item_person_count: product.participants
            ? [product.participants.min, product.participants.max].join('-')
            : undefined,
        item_location_count: isLocationSelected ? undefined : product.locationCount,
        ...(quantity ? { quantity } : {}),
        ...(itemListName ? { item_list_name: itemListName } : {}),
        ...(product.locationIsSelected !== undefined
            ? { item_list_location_selected: product.locationIsSelected }
            : {}),
        ...(product.closestLocationDistance
            ? { item_list_location_distance: product.closestLocationDistance }
            : {}),
        ...(product.discountBadgeId && { discount_badge_id: product.discountBadgeId }),
        ...(itemIfrs && { item_ifrs: Number(itemIfrs.toFixed(2)) }),
        ...(product.hasFriendsDiscount
            ? { item_quantity_discounted: quantity ? quantity - 1 : 0 }
            : {}),
        item_nudge_id: product.nudge?.id,
        item_nudge_name: product.nudge?.text,
        item_label_id: product.discountBadgeId,
        item_label_name: product.discountBadgeName,
        item_promotion_name: product.promotion,
    };
}
exports.buildGA4ProductDetail = buildGA4ProductDetail;
function buildGA4ProductDetailInteraction({ eventName, featureCategory, bookingType, product, appointment, variant, isLocationSelected, quantity, itemListName, }) {
    return {
        eventData: {
            eventName,
            feature_category: featureCategory,
            booking_type: bookingType,
            ecommerce: {
                items: [
                    buildGA4ProductDetail({
                        product,
                        appointment,
                        variant,
                        isLocationSelected,
                        quantity,
                        itemListName,
                    }),
                ],
            },
        },
    };
}
exports.buildGA4ProductDetailInteraction = buildGA4ProductDetailInteraction;
//# sourceMappingURL=buildGA4ProductDetail.js.map